import type { TIndentSize, TPadSize, TSize } from './models';

const DEFAULT_SIZE: TSize = 's';

const DEFAULT_INDENT_SIZE: TIndentSize = 'm';

const DEFAULT_PAD_SIZE: TPadSize = 'm';

export { DEFAULT_SIZE, DEFAULT_INDENT_SIZE, DEFAULT_PAD_SIZE };
